// extracted by css-extract-rspack-plugin
export default {"mark":"SMw35tk0BswJE9Qy","brandText":"K1zYcr6PMR7vQegw"};